export default {
  // PWA
  'app.pwa.offline': 'You are currently offline',
  'app.pwa.serviceworker.updated': 'New content available',
  'app.pwa.serviceworker.updated.hint':
    'Please click "Refresh" to get the latest content',
  'app.pwa.serviceworker.updated.ok': 'Refresh',

  // Global Header
  'component.globalHeader.search': 'Search',
  'component.globalHeader.search.example1': 'Search example 1',
  'component.globalHeader.search.example2': 'Search example 2',
  'component.globalHeader.search.example3': 'Search example 3',
  'component.globalHeader.help': 'Help',
  'component.globalHeader.notification': 'Notification',
  'component.globalHeader.notification.empty': 'No notifications',
  'component.globalHeader.message': 'Message',
  'component.globalHeader.message.empty': 'No messages',
  'component.globalHeader.event': 'Event',
  'component.globalHeader.event.empty': 'No events',

  // Settings
  'app.settings.menuMap.basic': 'Basic Settings',
  'app.settings.menuMap.security': 'Security Settings',
  'app.settings.menuMap.binding': 'Account Binding',
  'app.settings.menuMap.notification': 'New Message Notification',

  // Common Actions
  'app.common.operate': 'Operate',
  'app.common.more-operate': 'More',
  'app.common.add': 'Add',
  'app.common.edit': 'Edit',
  'app.common.delete': 'Delete',
  'app.common.view': 'View',
  'app.common.save': 'Save',
  'app.common.cancel': 'Cancel',
  'app.common.confirm': 'Confirm',
  'app.common.reset': 'Reset',
  'app.common.search': 'Search',
  'app.common.submit': 'Submit',
  'app.common.back': 'Back',
  'app.common.next': 'Next',
  'app.common.previous': 'Previous',
  'app.common.loading': 'Loading...',
  'app.common.no-data': 'No Data',
  'app.common.refresh': 'Refresh',
};
